module.exports = __webpack_public_path__ + "media/images/icon-1-05f479e7dc8a17a31c7fd64db57d130d.png";